import { useDispatch } from "react-redux";
import { useMemo, useState } from "react";
import clsx from "clsx";
import { useRouter } from "next/router";
import Link from "next/link";
import {
  fetchSection,
  setPageNum,
} from "../../../redux/action-creaters/section";
import styles from "./index.module.scss";
import Button from "../button";

export default function Pagen({
  count,
  size,
  currentNum,
  pagen = "PAGEN_1",
  isShowShowMore = false,
}) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const pageSize = size;
  const page = currentNum;
  const pagesCnt = Math.ceil(count / pageSize);

  const pages = () => {
    const pages = [1];

    let i = 1;
    let type = "begin";
    if (pagesCnt > 5) {
      if (page > 4) {
        type = "middle";
      }
      if (pagesCnt - page < 3) {
        type = "end";
      }
    }
    if (type === "begin") {
      while (i + 1 <= pagesCnt && pages.length < 5) {
        // eslint-disable-next-line no-plusplus
        i++;
        pages.push(i);
      }
      if (i < pagesCnt) {
        pages.push("...");
        pages.push(pagesCnt);
      }
    } else if (type === "middle") {
      pages.push("...");
      pages.push(page - 1);
      pages.push(page);
      pages.push(page + 1);
      pages.push("...");
      pages.push(pagesCnt);
    } else if (type === "end") {
      pages.push("...");
      i = pagesCnt - 5;
      while (i + 1 <= pagesCnt) {
        // eslint-disable-next-line no-plusplus
        i++;
        pages.push(i);
      }
    }
    return pages;
  };

  const path = useMemo(() => {
    return router.asPath.split("?")[0];
  }, [router]);

  return (
    <div className={styles.Buttom}>
      {isShowShowMore && page < pagesCnt && (
        <div className={styles.ShowMore}>
          <Button
            label="Показать еще"
            type="outline"
            isLoading={loading}
            onClick={async () => {
              setLoading(true);
              await dispatch(setPageNum(page + 1));
              await dispatch(await fetchSection());
              setLoading(false);

              if (typeof ym !== "undefined") {
                // eslint-disable-next-line no-undef
                ym(20518312, "reachGoal", "showMore");
              }
            }}
          />
        </div>
      )}
      <div className={styles.Pagen}>
        {pages().map((pageIndex) => (
          <Link
            key={pageIndex}
            href={`${path}${pageIndex > 1 ? `?${pagen}=${pageIndex}` : ""}`}
          >
            <a className={clsx(currentNum === pageIndex ? styles.Current : "")}>
              {pageIndex}
            </a>
          </Link>
        ))}
      </div>
    </div>
  );
}
